import Link from "next/link";

export const TermsCheckbox = ({
  checked,
  onChange,
  text,
  error,
  classNameForText = "terms_checkbox-text",
  classNameMain = "terms_checkbox-main",
  classNameContainer = "terms_checkbox-container",
  classNameError = "terms_checkbox-error",
}) => {
  return (
    <section className={classNameMain}>
      <label className="terms_checkbox-label">
        <div className={classNameContainer}>
          <input
            type="checkbox"
            value={text}
            checked={checked}
            onChange={() => onChange(!checked)}
          />
          <span className="terms_checkbox-box"></span>
        </div>
        <p className={classNameForText}>
          {text.beginning}
          <u>
            <Link className={"demyst-blue"} href={text.link1_url}>
              {text.link1_text}
            </Link>
          </u>
          {text.separator}
          <u>
            <Link className={"demyst-blue"} href={text.link2_url}>
              {text.link2_text}
            </Link>
          </u>
        </p>
      </label>
      <p className={classNameError}>{error}</p>
    </section>
  );
};
